import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Route, Routes} from 'react-router-dom';
import {connect} from 'react-redux';
import {
  actions,
  AuthError,
  ChooseModality,
  DeviceList,
  Email,
  Footer,
  ImprivataIdEnroll,
  ImprivataIdManual,
  ImprivataIdPush,
  Otp,
  Password,
  PasswordReset,
  Pin,
  Sms,
  SmsEnroll,
  TempCode,
  UsernamePassword,
  WaitingForEmr,
  ResumeAuthFlow,
  IcpFace,
  Username,
  ResumeAuthSession,
  Idv,
  HelpdeskVerificationResult
} from '@imprivata/common-auth-ui';

import {LoadingOverlay} from '@imprivata/nucleus';

class CommonAuthUserInterfaceWrapper extends Component {
  static propTypes = {
    startSession: PropTypes.func,
    modality: PropTypes.string,
    sessionException: PropTypes.object,
    sessionStarted: PropTypes.bool,
    startSessionEstablishing: PropTypes.bool,
    username: PropTypes.string,
    password: PropTypes.string,
    workflow: PropTypes.string,
    cidMobileServiceInfo: PropTypes.object,
    cidMobileServiceInfoInput: PropTypes.object,
    cidErrorCode: PropTypes.string,
    authenticationToken: PropTypes.string,
    complete: PropTypes.bool,
    isLoading: PropTypes.bool,
    contextDataToken: PropTypes.string,
    cloudEnv: PropTypes.string,
    ssdmEnv: PropTypes.string,
    product: PropTypes.string,
    authContextRedirectUrl: PropTypes.string,
    onAuthTokenReceived: PropTypes.func,
    onWsFedResultReceived: PropTypes.func,
    onErrorReceived: PropTypes.func,
    audience: PropTypes.string,
    responseURL: PropTypes.string,
    jti: PropTypes.string
  };

  logRed = (message) => {
    console.log('%c' + new Date().toLocaleString() + ' %c' + message, 'color: #C61F2C', 'color:#61b84d');
  };

  async componentDidMount() {
    this.setUsername(this.props.usernameInput);
    this.setResumeAuthFlowTokenUrl(this.props.resumeAuthFlowTokenUrlInput);
    this.setErrorHandlerUrl(this.props.errorHandlerUrlInput);
    this.setForceMfa(this.props.forceMfaInput)
    this.startSession();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {

    if (!prevProps.complete && this.props.complete) {
      if (this.props.onAuthTokenReceived) {
        const redirectUrl = this.props.authContextRedirectUrl;
        this.props.onAuthTokenReceived(this.props.authenticationToken, redirectUrl);
      }
    }
    if (!prevProps.wsFedWresult && this.props.wsFedWresult) {
      if (this.props.onWsFedResultReceived) {
        this.props.onWsFedResultReceived(this.props.wsFedWa, this.props.wsFedWctx, this.props.wsFedWresult, this.props.wsFedUrl);
      }
    }
    if (!this.props.sessionStarted  && !this.props.sessionException && !this.props.startSessionEstablishing) {
      await this.startSession();
    }

    //error handling only for cidMobile errors
    if(this.props.sessionException !== null && this.props.onErrorReceived && prevProps.sessionException !== this.props.sessionException)
    {
      const errorCode = encodeURIComponent(this.props.cidErrorCode) + '';
      const errorMessage = this.props.cidErrorMessage;
      this.props.onErrorReceived(errorCode, errorMessage);
    }
  }

  startSession = async () => {
    this.logRed(`Starting session for ` + this.props.product);
    if (!this.props.sessionStarted && !this.props.sessionException) {
      this.logRed(`Context token: ${this.props.contextDataToken}, Environment: ${this.props.cloudEnv}, SelfServiceEnvironment: ${this.props.ssdmEnv}`);
      if (this.props.jti) {
        this.props.resumeSession(this.props.jti);
      }
      else {
        let sessionUsername = (this.props.usernameInput ? this.props.usernameInput : this.props.username);
        let sessionWorkflow = (this.props.workflowInput ? this.props.workflowInput : this.props.workflow);
        this.props.startSession(this.props.contextDataToken, this.props.cloudEnv, this.props.ssdmEnv,
          sessionUsername, sessionWorkflow, this.props.cidMobileServiceInfoInput);
      }
    }
  };

  setUsername = async  (username) => {
    this.props.setInitialUsername(username)
  }

  setResumeAuthFlowTokenUrl = async  (resumeAuthFlowTokenUrl) => {
    this.props.setResumeAuthFlowTokenUrl(resumeAuthFlowTokenUrl)
  }

  setErrorHandlerUrl = async (errorHandlerUrl) => {
    this.props.setErrorHandlerUrl(errorHandlerUrl)
  }

  setForceMfa = async  (forceMfa) => {
    this.props.setForceMfa(forceMfa)
  }

  render() {
    if (!this.props.sessionStarted && !this.props.sessionException) {
      return (
          <LoadingOverlay showOverlay/>
      );
    }
    this.logRed('Modality: ' + this.props.modality);
    return (
        <div>
          <Routes>
            <Route path="/autherror" element={<AuthError />} />
            <Route path="/choosemodality" element={<ChooseModality />} />
            <Route path="/devicelist" element={<DeviceList />} />
            <Route path="/email" element={<Email />} />
            <Route path="/enrollsms" element={<SmsEnroll />} />
            <Route path="/enrollimprivataid" element={<ImprivataIdEnroll />} />
            <Route path="/iid-manual" element={<ImprivataIdManual />} />
            <Route path="/iid" element={<ImprivataIdPush />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/password" element={<Password />} />
            <Route path="/password-reset" element={<PasswordReset />} />
            <Route path="/pin" element={<Pin />} />
            <Route path="/sms" element={<Sms />} />
            <Route path="/username-password" element={<UsernamePassword />} />
            <Route path="/tempcode" element={<TempCode />} />
            <Route path="/waitingforemr" element={<WaitingForEmr />} />
            <Route path="/resume-auth-flow" element={<ResumeAuthFlow />} />
            <Route path="/face" element={<IcpFace />} />
            <Route path="/username" element={<Username />} />
            <Route path="/resume-auth-session" element={<ResumeAuthSession />} />
            <Route path="/idv" element={<Idv />} />
            <Route path="/helpdesk-verification-finish" element={<HelpdeskVerificationResult />} />
          </Routes>
          <Footer/>
          <LoadingOverlay showOverlay={this.props.isLoading}/>
        </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    sessionStarted, startSessionEstablishing, modality, sessionException, isLoading, username, password, cidMobileServiceInfo,
    authenticationToken, complete, serverState, manuallyProceedToTempCode, cidErrorCode, cidErrorMessage, sessionVersion,
    wsFedWa, wsFedWctx, wsFedWresult, wsFedUrl, authContextRedirectUrl,} = state.login;
  return {
    sessionStarted,
    startSessionEstablishing,
    modality,
    sessionException,
    username,
    password,
    cidMobileServiceInfo,
    authenticationToken,
    complete,
    isLoading,
    serverState,
    manuallyProceedToTempCode,
    cidErrorCode,
    cidErrorMessage,
    sessionVersion,
    wsFedWa,
    wsFedWctx,
    wsFedWresult,
    wsFedUrl,
    authContextRedirectUrl,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startSession: (contextDataToken, environment, selfServiceEnvironment, username, workflow, cidMobileServiceInfo) => {
      dispatch(actions.startSession(contextDataToken, environment,
          selfServiceEnvironment, username, workflow, cidMobileServiceInfo));
    },
    setInitialUsername: (username) => {
      dispatch(actions.setInitialUsername(username))
    },
    setResumeAuthFlowTokenUrl: (resumeAuthFlowTokenUrl) => {
      dispatch(actions.setResumeAuthFlowTokenUrl(resumeAuthFlowTokenUrl))
    },
    setErrorHandlerUrl: (errorHandlerUrl) => {
      dispatch(actions.setErrorHandlerUrl(errorHandlerUrl))
    },
    setForceMfa: (forceMfa) => {
      dispatch(actions.setForceMfa(forceMfa))
    },
    resumeSession: (jti) => {
      dispatch(actions.resumeSession(jti))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps) (CommonAuthUserInterfaceWrapper);
